import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom, APP_INITIALIZER } from '@angular/core';
import { RouteReuseStrategy, Router, provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { registerLocaleData } from '@angular/common';
import fa from '@angular/common/locales/fa';
import { fa_IR, provideNzI18n } from 'ng-zorro-antd/i18n';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NzConfig, provideNzConfig } from 'ng-zorro-antd/core/config';

import { UserPermissionService } from './shared/services/user-permission.service';
import { provideNzWave } from 'ng-zorro-antd/core/wave';
import { NzNoAnimationModule } from 'ng-zorro-antd/core/no-animation';
import { CustomReuseStrategy } from './customReuseStartegy';
import { WebSocketService } from './shared/services/web-socket.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { initializeWebSocket } from './startup-service';

export function initializeAppCustomLogic(
  userPermissionService: UserPermissionService,
  router: Router
) {
  return () => {
    const user = localStorage.getItem('user');
    if (user) {
      userPermissionService.loadPermission();
    }
  };
}

registerLocaleData(fa);

const ngZorroConfig: NzConfig = {
  message: {
    nzTop: 50, nzDuration: 4000, nzMaxStack: 3, nzPauseOnHover: true
  },
  notification: {
    nzTop: 20,
    nzDirection: 'rtl',
    nzMaxStack: 3,
    nzDuration: 4000,
    nzPauseOnHover: true,
    nzPlacement: 'bottomLeft',
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(),
    provideHttpClient(),
    provideAnimationsAsync("noop"),
    provideNzWave({ disabled: true }),
    provideNzI18n(fa_IR),
    importProvidersFrom(
      // FormsModule,
      // ReactiveFormsModule,
      NgxPermissionsModule.forRoot(),
      NzNoAnimationModule
    ),
    provideNzConfig(ngZorroConfig),
    NzMessageService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeWebSocket,
      deps: [WebSocketService],
      multi: true
    }
  ]
};
